import { uniqBy } from "lodash";
import { useState } from "react";
import { Checkbox, Header, Message, Segment, Table } from "semantic-ui-react";
import { useNotifySettingsPublic } from "../../../../../../hooks/useNotifySettingsPublic";
import { useNotifySubscriberContactMethodsForLoggedInUser } from "../../../../../../hooks/useNotifySubscriberContactMethodsForLoggedInUser";
import { useNotifySubscriptionGroupsPublic } from "../../../../../../hooks/useNotifySubscriptionGroupsPublic";
import { SignUpModal } from "../modals/SignUpModal";

export function PublicSubscriptionGroupsTable() {
  const [signUpModalData, setSignUpModalData] = useState<{ type: "Email" | "Phone" } | null>(null);

  const { subscriberContactMethods } = useNotifySubscriberContactMethodsForLoggedInUser();
  const subscriberContactMethod = subscriberContactMethods?.at(0);

  const { publicSubscriptionGroups } = useNotifySubscriptionGroupsPublic();
  const hasSubscriptionGroups = publicSubscriptionGroups && publicSubscriptionGroups?.length > 0;

  const subscriptionGroups = uniqBy(
    [...(publicSubscriptionGroups ?? []), ...(subscriberContactMethod?.subscriptionGroups ?? [])],
    "id",
  );

  const { isConfigured } = useNotifySettingsPublic();

  return (
    <>
      <SignUpModal data={signUpModalData} onClose={() => setSignUpModalData(null)} />
      {!hasSubscriptionGroups && (
        <Message>
          <Message.Header>No Subscription Groups</Message.Header>
          <p>There are no subscription groups available for you to subscribe to.</p>
        </Message>
      )}
      {hasSubscriptionGroups && (
        <div>
          {/* Display table when screen is medium or larger */}
          <Table className='tw-hidden md:tw-table'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Group</Table.HeaderCell>
                {isConfigured && <Table.HeaderCell className='tw-w-36'>SMS & Voice</Table.HeaderCell>}
                <Table.HeaderCell className='tw-w-36'>Email</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {subscriptionGroups?.map((group) => (
                <Table.Row key={group.id}>
                  <Table.Cell>
                    <Header as='h4' className='tw-m-0 tw-text-base'>
                      {group.name}
                    </Header>
                    <p className='tw-m-0 tw-text-black-light'>{group.description}</p>
                  </Table.Cell>
                  <Table.Cell>
                    {isConfigured && (
                      <Checkbox toggle checked={false} onChange={() => setSignUpModalData({ type: "Phone" })} />
                    )}
                  </Table.Cell>
                  <Table.Cell>
                    <Checkbox toggle checked={false} onChange={() => setSignUpModalData({ type: "Email" })} />
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
          {/* Display cards when screen is smaller than medium */}
          <div className='tw-space-y-2 md:tw-hidden'>
            {subscriptionGroups?.map((group) => (
              <Segment key={group.id} className='tw-m-0 tw-flex tw-flex-col tw-gap-3'>
                <div className='tw-space-y-1'>
                  <Header as='h3' className='tw-m-0 tw-text-lg'>
                    {group.name}
                  </Header>
                  <p className='tw-m-0'>{group.description}</p>
                </div>
                <div className='tw-flex tw-flex-col tw-gap-2'>
                  {isConfigured && (
                    <Checkbox
                      label='SMS & Voice'
                      toggle
                      checked={false}
                      onChange={() => setSignUpModalData({ type: "Phone" })}
                    />
                  )}
                  <Checkbox
                    label='Email'
                    toggle
                    checked={false}
                    onChange={() => setSignUpModalData({ type: "Email" })}
                  />
                </div>
              </Segment>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
